import { render, staticRenderFns } from "./StatusItem.vue?vue&type=template&id=34e8fb27&scoped=true&"
import script from "./StatusItem.vue?vue&type=script&lang=js&"
export * from "./StatusItem.vue?vue&type=script&lang=js&"
import style0 from "./StatusItem.vue?vue&type=style&index=0&id=34e8fb27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e8fb27",
  null
  
)

export default component.exports